// import CardPropertyObjectTable from '../../components/Card/CardPropertyObjectTable.vue'
import OrganizationCardSectionProvidableVehicles from './OrganizationCardSectionProvidableVehicles.vue'
import OrganizationCardSectionProvidableDrivers from './OrganizationCardSectionProvidableDrivers.vue'
import OrganizationCardSectionProvidableVehicleGroupTypes from './OrganizationCardSectionProvidableVehicleGroupTypes.vue'
import OrganizationPropertyContacts from './OrganizationPropertyContacts.vue'

export function getCustomTabsList (config) {
  const { create, createConfig, access, subtypeKey, objectData } = config

  const descriptionPropsEditAccess = access.approvalAccess
  const oneCPropsEditAccess = false // 1C

  return [
    {
      key: 'params',
      name: 'Основное',
      props: [
        // { key: '$key', name: 'Идентификатор организации', _visible: !create && access.fullAccess, _editable: false },
        { key: 'alias', name: 'Короткое название', _editable: descriptionPropsEditAccess },
        { key: 'contactData', name: 'Контактные данные', _editable: descriptionPropsEditAccess, component: OrganizationPropertyContacts },
        { key: 'vehicleProvider', name: 'Поставщик ТС', _editable: descriptionPropsEditAccess },
        { key: 'vehicleGroupProvider', name: 'Поставщик Групп ТС', _editable: descriptionPropsEditAccess }
        // {
        //   key: 'vehicleGroupTypeProviderOrganization',
        //   name: 'Предоставляемые Типы групп ТС',
        //   _editable: false,
        //   component: CardPropertyObjectTable
        // }
      ]
    },
    {
      key: 'organizationInfo',
      name: 'Доп. сведения',
      _visible: access.approvalAccess,
      props: [
        { key: '$key', name: 'Идентификатор организации', _visible: !create && access.fullAccess, _editable: false },
        { key: 'name1c', name: 'Название организации в 1С', _editable: oneCPropsEditAccess },
        { key: 'incorporationForm', name: 'Организационно правовая-форма', _editable: oneCPropsEditAccess },
        { key: 'registrationAddress', name: 'Адрес регистрации', _editable: oneCPropsEditAccess },
        { key: 'inn', name: 'ИНН', _editable: oneCPropsEditAccess },
        { key: 'kpp', name: 'КПП', _editable: oneCPropsEditAccess },
        { key: 'ogrn', name: 'ОГРН', _editable: oneCPropsEditAccess },
        { key: 'ogrnip', name: 'ОГРНИП', _editable: oneCPropsEditAccess },
        { key: 'okato', name: 'ОКАТО', _editable: oneCPropsEditAccess },
        { key: 'okved', name: 'ОКВЭД', _editable: oneCPropsEditAccess },
        { key: 'okpo', name: 'ОКПО', _editable: oneCPropsEditAccess },
        { key: 'oktmo', name: 'ОКТМО', _editable: oneCPropsEditAccess },
        { key: 'note', name: 'Примечания', _editable: oneCPropsEditAccess }
      ]
    },
    {
      key: 'organizationProvidableVehicles',
      name: 'Предоставляемые ТС',
      _show: o => !!o.vehicleProvider,
      component: OrganizationCardSectionProvidableVehicles
    },
    {
      key: 'organizationProvidableDrivers',
      name: 'Водители',
      _show: o => !!o.vehicleProvider,
      component: OrganizationCardSectionProvidableDrivers
    },
    {
      key: 'organizationProvidableVehicleGroupTypes',
      name: 'Типы групп ТС',
      _show: o => !!o.vehicleGroupProvider,
      component: OrganizationCardSectionProvidableVehicleGroupTypes
    }
  ]
}
